import graphql from "babel-plugin-relay/macro";
import { isAfter } from "date-fns";
import { readInlineData } from "react-relay";

import { convertDateStringToObj } from "@whoosh/utilities/src/dates";

import { packagePaymentMethodExpired_memberPackage$key } from "./__generated__/packagePaymentMethodExpired_memberPackage.graphql";

export const packagePaymentMethodExpired = (
  memberPackageRef?: packagePaymentMethodExpired_memberPackage$key | null
) => {
  const memberPackage = readInlineData(
    packagePaymentMethodExpiredFragmentString,
    memberPackageRef
  );

  const dueDates =
    memberPackage?.orders?.edges?.flatMap((e) =>
      e?.node?.packageDueDate
        ? [convertDateStringToObj(e.node.packageDueDate)]
        : []
    ) || [];

  const squareCard = memberPackage?.squareCard;
  if (!squareCard) return false;

  const cardExpirationDate = new Date(
    squareCard.expYear,
    squareCard.expMonth - 1,
    1
  );

  return dueDates.some((dueDate) => isAfter(dueDate, cardExpirationDate));
};

const packagePaymentMethodExpiredFragmentString = graphql`
  fragment packagePaymentMethodExpired_memberPackage on MemberPackage @inline {
    package {
      billingType
    }
    orders {
      edges {
        node {
          packageDueDate
        }
      }
    }
    squareCard {
      id
      expMonth
      expYear
    }
  }
`;
